import React from 'react';
import { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';



function Footer() {
    
    const [urlwhatsapp, setUrlwhatsapp] = useState('9833513355');
    const [message, setMessage] = useState('Hola, buen día, me gustaría solicitar cotización.');

    return (
        <div>
            <footer id="footer" className="footer style-03">
                <div className="section-001 section-020">
                    <div className="container">
                        <div className="kreen-newsletter style-03">
                            <div className="newsletter-inner">
                                <div className="newsletter-info">
                                    <div className="newsletter-wrap">
                                        <h3 className="title">Distribuidora de mariscos</h3>
                                        <h4 className="subtitle">San José</h4>
                                        {
                                            //<p className="desc">Nam sed felis at eros blandit ultrices et quis quam. In sit amet molestie lectus.</p>
                                        }
                                    </div>
                                </div>
                                {
                                    /*
                                        <div className="newsletter-form-wrap">
                                            <div className="newsletter-form-inner">
                                                <input className="email email-newsletter" name="email" placeholder="Enter your email ..."
                                                    type="email" />
                                                <a href="#" className="button btn-submit submit-newsletter">
                                                    <span className="text">Subscribe</span>
                                                </a>
                                            </div>
                                        </div>
                                    */
                                }
                            </div>
                        </div>
                        <div className="kreen-socials style-02">
                            <div className="content-socials">
                                <ul className="socials-list">
                                    <li>
                                        <a href="https://facebook.com/DistribuidorademariscosSJ" target="_blank">
                                            <i className="fa fa-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="https://www.instagram.com/distribuidorademariscossj" target="_blank">
                                            <i className="fa fa-instagram"></i>
                                        </a>
                                    </li>
                                    {
                                        /*
                                        <li>
                                            <a href="https://twitter.com" target="_blank">
                                                <i className="fa fa-twitter"></i>
                                            </a>
                                        </li>
                                        <li>
                                            <a href="https://www.pinterest.com" target="_blank">
                                                <i className="fa fa-pinterest-p"></i>
                                            </a>
                                        </li>
                                        */
                                    }
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section-021">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6">
                                <p>© Copyright 2025 <a href="#">San José</a>. All Rights Reserved.</p>
                            </div>
                            <div className="col-md-6">
                                <div className="kreen-listitem style-03">
                                    <div className="listitem-inner">
                                        {
                                            <ul className="listitem-list">
                                                <li>
                                                    <a href="https://api.whatsapp.com/send?phone=529833513355&text=Hola, buen día, me gustaría solicitar cotización." target="_blank">
                                                        <i className="fa fa-whatsapp"></i> Whatsapp 
                                                    </a>
                                                </li>
                                            </ul>
                                            /*
                                            <ul className="listitem-list">
                                                <li>
                                                    <a href="#" target="_self">
                                                        Contacto 
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#" target="_self">
                                                        Términos &amp; Condiciones 
                                                    </a>
                                                </li>
                                                <li>
                                                    <a href="#" target="_self">
                                                        Envío 
                                                    </a>
                                                </li>
                                            </ul>
                                            */
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            <div className="footer-device-mobile">
                <div className="wapper">
                    <div className="footer-device-mobile-item device-home">
                        <a href="/">
                                <span className="icon">
                                    <span className="pe-7s-home"></span>
                                </span>
                            Inicio
                        </a>
                    </div>
                    {
                        /**
                        
                            <div className="footer-device-mobile-item device-home device-wishlist">
                                <a href="wishlist.html">
                                        <span className="icon">
                                            <span className="pe-7s-like"></span>
                                        </span>
                                    Lista de deseos
                                </a>
                            </div>
                            <div className="footer-device-mobile-item device-home device-cart">
                                <a href="cart.html">
                                        <span className="icon">
                                            <span className="pe-7s-shopbag"></span>
                                            <span className="count-icon">
                                                0
                                            </span>
                                        </span>
                                    <span className="text">Carrito</span>
                                </a>
                            </div>
                            <div className="footer-device-mobile-item device-home device-user">
                                <a href="my-account.html">
                                        <span className="icon">
                                            <span className="pe-7s-user"></span>
                                        </span>
                                    Cuenta
                                </a>
                            </div>
                         */
                    }
                </div>
            </div>
        </div>
    );
}

export default Footer;